import { defineStore } from 'pinia'

import api from '@/api/api'
import { StoreAddOn, parseAddOn } from '@/models'
import { sortBy, upsertById } from '@/utils/utils'

import { AddOnRead } from '@generated/types'

export interface AddOnState {
  addOns: StoreAddOn[]
}

export const useAddOnStore = defineStore({
  id: 'addOn',
  state: (): AddOnState => ({
    addOns: [],
  }),
  getters: {},
  actions: {
    storeAddOn(addOn: AddOnRead): AddOnRead {
      const model = upsertById(parseAddOn(addOn), this.addOns)
      sortBy(this.addOns, 'name')
      return model
    },
    async fetchAll() {
      const response = await api.getAddOns()
      response.data.map(this.storeAddOn)
    },
  },
})
